const keys = [
  'searchTitle', 'searchPlaceholder', 'searchEvents', 'searchPeople',
  'searchNoEvents', 'searchNoPeople', 'searchAddPrompt', 'searchClear', 'searchRetry',
  'searchMore', 'searchError', 'searchTooLong', 'searchShort', 'searchInvalid',
  'searchAddEvent', 'searchBack', 'searchLoading', 'searchResultCount',
];

const labels = {
  en: [
    'Search events and people', 'Event, name or @username', 'Events', 'People',
    'No events found', 'No people found',
    'Didn’t find the event?', 'Clear search', 'Try again', 'Load more',
    'Could not load the results. Please try again.', 'Keep your search within 120 characters.',
    'Enter at least two characters.', 'Check the characters in your search.',
    'Add an event', 'Back to feed', 'Searching', 'Results: {{count}}',
  ],
  ru: [
    'Поиск событий и людей', 'Событие, имя или @ник', 'События', 'Люди',
    'Событий не найдено', 'Пользователей не найдено',
    'Не нашли нужное событие?', 'Очистить поиск', 'Попробовать снова', 'Показать ещё',
    'Не удалось загрузить результаты. Попробуйте снова.', 'Запрос должен быть не длиннее 120 символов.',
    'Введите хотя бы два символа.', 'Проверьте символы в поисковом запросе.',
    'Добавить событие', 'Вернуться в ленту', 'Поиск', 'Найдено: {{count}}',
  ],
  es: [
    'Buscar eventos y personas', 'Evento, nombre o @usuario', 'Eventos', 'Personas',
    'No se encontraron eventos', 'No se encontraron personas',
    '¿No encontraste el evento?', 'Borrar búsqueda', 'Volver a intentar', 'Cargar más',
    'No se pudieron cargar los resultados. Inténtalo de nuevo.', 'La búsqueda no puede superar los 120 caracteres.',
    'Escribe al menos dos caracteres.', 'Revisa los caracteres de tu búsqueda.',
    'Añadir un evento', 'Volver al inicio', 'Buscando', 'Resultados: {{count}}',
  ],
  fr: [
    'Rechercher des événements et des personnes', 'Événement, nom ou @pseudo', 'Événements', 'Personnes',
    'Aucun événement trouvé', 'Aucune personne trouvée',
    'Vous n’avez pas trouvé l’événement ?', 'Effacer la recherche', 'Réessayer', 'Afficher plus',
    'Impossible de charger les résultats. Réessayez.', 'La recherche ne doit pas dépasser 120 caractères.',
    'Saisissez au moins deux caractères.', 'Vérifiez les caractères de votre recherche.',
    'Ajouter un événement', 'Retour au fil', 'Recherche en cours', 'Résultats : {{count}}',
  ],
  de: [
    'Ereignisse und Personen suchen', 'Ereignis, Name oder @Nutzername', 'Ereignisse', 'Personen',
    'Keine Ereignisse gefunden', 'Keine Personen gefunden',
    'Ereignis nicht gefunden?', 'Suche löschen', 'Erneut versuchen', 'Mehr laden',
    'Die Ergebnisse konnten nicht geladen werden. Versuche es erneut.', 'Die Suche darf höchstens 120 Zeichen enthalten.',
    'Gib mindestens zwei Zeichen ein.', 'Prüfe die Zeichen deiner Suche.',
    'Ereignis hinzufügen', 'Zurück zum Feed', 'Suche läuft', 'Ergebnisse: {{count}}',
  ],
  it: [
    'Cerca eventi e persone', 'Evento, nome o @utente', 'Eventi', 'Persone',
    'Nessun evento trovato', 'Nessuna persona trovata',
    'Non hai trovato l’evento?', 'Cancella ricerca', 'Riprova', 'Carica altro',
    'Impossibile caricare i risultati. Riprova.', 'La ricerca non può superare 120 caratteri.',
    'Inserisci almeno due caratteri.', 'Controlla i caratteri della ricerca.',
    'Aggiungi un evento', 'Torna al feed', 'Ricerca in corso', 'Risultati: {{count}}',
  ],
  pt: [
    'Buscar eventos e pessoas', 'Evento, nome ou @usuário', 'Eventos', 'Pessoas',
    'Nenhum evento encontrado', 'Nenhuma pessoa encontrada',
    'Não encontrou o evento?', 'Limpar busca', 'Tentar novamente', 'Carregar mais',
    'Não foi possível carregar os resultados. Tente novamente.', 'A busca deve ter no máximo 120 caracteres.',
    'Digite pelo menos dois caracteres.', 'Confira os caracteres da busca.',
    'Adicionar evento', 'Voltar ao feed', 'Buscando', 'Resultados: {{count}}',
  ],
  tr: [
    'Olay ve kişi ara', 'Olay, ad veya @kullanıcı', 'Olaylar', 'Kişiler',
    'Olay bulunamadı', 'Kişi bulunamadı',
    'Aradığınız olayı bulamadınız mı?', 'Aramayı temizle', 'Tekrar dene', 'Daha fazla yükle',
    'Sonuçlar yüklenemedi. Tekrar deneyin.', 'Arama en fazla 120 karakter içermelidir.',
    'En az iki karakter girin.', 'Aramanızdaki karakterleri kontrol edin.',
    'Olay ekle', 'Akışa dön', 'Aranıyor', 'Sonuçlar: {{count}}',
  ],
  ja: [
    '出来事とユーザーを検索', '出来事、名前、@ユーザー名', '出来事', 'ユーザー',
    '出来事が見つかりません', 'ユーザーが見つかりません',
    'お探しの出来事が見つかりませんか？', '検索をクリア', 'もう一度試す', 'さらに読み込む',
    '検索結果を読み込めませんでした。もう一度お試しください。', '検索は120文字以内で入力してください。',
    '英数字は2文字以上入力してください。', '検索文字列を確認してください。',
    '出来事を追加', 'フィードに戻る', '検索中', '検索結果：{{count}}件',
  ],
  ko: [
    '사건 및 사용자 검색', '사건, 이름 또는 @사용자명', '사건', '사용자',
    '사건을 찾을 수 없습니다', '사용자를 찾을 수 없습니다',
    '원하는 사건을 찾지 못했나요?', '검색 지우기', '다시 시도', '더 보기',
    '검색 결과를 불러오지 못했습니다. 다시 시도해 주세요.', '검색어는 120자 이내로 입력하세요.',
    '영문과 숫자는 두 글자 이상 입력하세요.', '검색어의 문자를 확인하세요.',
    '사건 추가', '피드로 돌아가기', '검색 중', '검색 결과: {{count}}개',
  ],
  zh: [
    '搜索事件和用户', '事件、姓名或 @用户名', '事件', '用户',
    '未找到事件', '未找到用户',
    '没有找到想要的事件？', '清除搜索', '重试', '加载更多',
    '无法加载搜索结果，请重试。', '搜索内容不能超过120个字符。',
    '英文字母或数字请至少输入两个字符。', '请检查搜索内容中的字符。',
    '添加事件', '返回动态', '正在搜索', '结果：{{count}}',
  ],
  hi: [
    'घटनाएँ और लोग खोजें', 'घटना, नाम या @यूज़रनेम', 'घटनाएँ', 'लोग',
    'कोई घटना नहीं मिली', 'कोई उपयोगकर्ता नहीं मिला',
    'मनचाही घटना नहीं मिली?', 'खोज साफ़ करें', 'फिर कोशिश करें', 'और दिखाएँ',
    'खोज के नतीजे लोड नहीं हो सके। फिर कोशिश करें।', 'खोज में अधिकतम 120 वर्ण दर्ज करें।',
    'कम से कम दो वर्ण दर्ज करें।', 'खोज में दर्ज वर्णों की जाँच करें।',
    'घटना जोड़ें', 'फ़ीड पर वापस जाएँ', 'खोज जारी है', 'नतीजे: {{count}}',
  ],
};

const translations = Object.fromEntries(Object.entries(labels).map(([language, values]) => [
  language, Object.fromEntries(keys.map((key, index) => [key, values[index]])),
]));

export default translations;
